"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CategoryBanner;
const react_1 = __importDefault(require("react"));
const SharedDuplexBanner_1 = __importDefault(require("../SharedDuplexBanner/SharedDuplexBanner"));
const SharedImageBanner_1 = __importDefault(require("../SharedImageBanner/SharedImageBanner"));
function CategoryBanner(props) {
    if (props.designType === "largeDuplex" ||
        props.designType === "smallDuplex") {
        return react_1.default.createElement(SharedDuplexBanner_1.default, Object.assign({}, props, { testId: "category" }));
    }
    if (props.designType === "smallImage" || props.designType === "largeImage") {
        return react_1.default.createElement(SharedImageBanner_1.default, Object.assign({}, props, { testId: "category" }));
    }
    return null;
}
